import { cyrb53 } from "./cyrb53.js";
export const toTitleCase = (str) => {
    if (!str)
        return str;
    return str.replace(/[A-Za-z0-9]+/g, (txt) => {
        return txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase();
    });
};
export const getTextHash = (text) => {
    // Normalize text to ensure consistent hashing:
    // 1. Trim whitespace from start/end
    // 2. Convert to lowercase
    // 3. Remove all non-alphanumeric characters except spaces
    // 4. Collapse multiple spaces into single space
    const normalizedText = text
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9\s]/g, "")
        .replace(/\s+/g, " ");
    return cyrb53(normalizedText);
};
export const keyToTitle = (key) => {
    return key
        .split("-")
        .map((s) => toTitleCase(s))
        .join(" ");
};
export function escapeRegex(str) {
    return str.replace(/[/\\^$*+?.()|[\]{}]/g, "\\$&");
}
export function normalizeQuotes(str) {
    // double quotes
    let normalized = str.replace(/“/g, '"').replace(/”/g, '"');
    // single quotes
    normalized = normalized.replace(/’/g, "'").replace(/‘/g, "'");
    // backticks
    normalized = normalized.replace(/`/g, "'");
    return normalized;
}
export function levenshteinDistance(a, b) {
    if (a.length === 0)
        return b.length;
    if (b.length === 0)
        return a.length;
    const matrix = Array(b.length + 1)
        .fill(0)
        .map(() => Array(a.length + 1).fill(0));
    for (let i = 0; i <= a.length; i++) {
        matrix[0][i] = i;
    }
    for (let j = 0; j <= b.length; j++) {
        matrix[j][0] = j;
    }
    for (let j = 1; j <= b.length; j++) {
        for (let i = 1; i <= a.length; i++) {
            const substitutionCost = a[i - 1] === b[j - 1] ? 0 : 1;
            matrix[j][i] = Math.min(matrix[j][i - 1] + 1, // deletion
            matrix[j - 1][i] + 1, // insertion
            matrix[j - 1][i - 1] + substitutionCost);
        }
    }
    return matrix[b.length][a.length];
}
export function stateToAbbreviation(str) {
    if (str == "unknown") {
        return str;
    }
    const stateMap = {
        // US States
        alabama: "AL",
        alaska: "AK",
        arizona: "AZ",
        arkansas: "AR",
        california: "CA",
        colorado: "CO",
        connecticut: "CT",
        delaware: "DE",
        florida: "FL",
        georgia: "GA",
        hawaii: "HI",
        idaho: "ID",
        illinois: "IL",
        indiana: "IN",
        iowa: "IA",
        kansas: "KS",
        kentucky: "KY",
        louisiana: "LA",
        maine: "ME",
        maryland: "MD",
        massachusetts: "MA",
        michigan: "MI",
        minnesota: "MN",
        mississippi: "MS",
        missouri: "MO",
        montana: "MT",
        nebraska: "NE",
        nevada: "NV",
        "new hampshire": "NH",
        "new jersey": "NJ",
        "new mexico": "NM",
        "new york": "NY",
        "north carolina": "NC",
        "north dakota": "ND",
        ohio: "OH",
        oklahoma: "OK",
        oregon: "OR",
        pennsylvania: "PA",
        "rhode island": "RI",
        "south carolina": "SC",
        "south dakota": "SD",
        tennessee: "TN",
        texas: "TX",
        utah: "UT",
        vermont: "VT",
        virginia: "VA",
        washington: "WA",
        "west virginia": "WV",
        wisconsin: "WI",
        wyoming: "WY",
        // Canadian Provinces and Territories
        alberta: "AB",
        "british columbia": "BC",
        manitoba: "MB",
        "new brunswick": "NB",
        "newfoundland and labrador": "NL",
        "northwest territories": "NT",
        "nova scotia": "NS",
        nunavut: "NU",
        ontario: "ON",
        "prince edward island": "PE",
        quebec: "QC",
        saskatchewan: "SK",
        yukon: "YT",
    };
    return stateMap[str.toLowerCase()] ?? str;
}
export function stateAbbreviationToFull(str) {
    const stateMap = {
        // US States
        AL: "Alabama",
        AK: "Alaska",
        AZ: "Arizona",
        AR: "Arkansas",
        CA: "California",
        CO: "Colorado",
        CT: "Connecticut",
        DE: "Delaware",
        FL: "Florida",
        GA: "Georgia",
        HI: "Hawaii",
        ID: "Idaho",
        IL: "Illinois",
        IN: "Indiana",
        IA: "Iowa",
        KS: "Kansas",
        KY: "Kentucky",
        LA: "Louisiana",
        ME: "Maine",
        MD: "Maryland",
        MA: "Massachusetts",
        MI: "Michigan",
        MN: "Minnesota",
        MS: "Mississippi",
        MO: "Missouri",
        MT: "Montana",
        NE: "Nebraska",
        NV: "Nevada",
        NH: "New Hampshire",
        NJ: "New Jersey",
        NM: "New Mexico",
        NY: "New York",
        NC: "North Carolina",
        ND: "North Dakota",
        OH: "Ohio",
        OK: "Oklahoma",
        OR: "Oregon",
        PA: "Pennsylvania",
        RI: "Rhode Island",
        SC: "South Carolina",
        SD: "South Dakota",
        TN: "Tennessee",
        TX: "Texas",
        UT: "Utah",
        VT: "Vermont",
        VA: "Virginia",
        WA: "Washington",
        WV: "West Virginia",
        WI: "Wisconsin",
        WY: "Wyoming",
        // Canadian Provinces and Territories
        AB: "Alberta",
        BC: "British Columbia",
        MB: "Manitoba",
        NB: "New Brunswick",
        NL: "Newfoundland and Labrador",
        NT: "Northwest Territories",
        NS: "Nova Scotia",
        NU: "Nunavut",
        ON: "Ontario",
        PE: "Prince Edward Island",
        QC: "Quebec",
        SK: "Saskatchewan",
        YT: "Yukon",
    };
    return stateMap[str.toUpperCase()] ?? str;
}
